{
  "HEADER": {
    "TITLE": "PrimeNG + Tailwind Integration",
    "DESCRIPTION": "This component demonstrates the seamless integration between PrimeNG components and Tailwind CSS utilities in Angular 20 with internationalization support."
  },
  "LANGUAGE": {
    "LABEL": "Language:"
  },
  "COLORS": {
    "TITLE": "Tailwind-PrimeUI Color Palette"
  },
  "FORM": {
    "TITLE": "Responsive Form with PrimeNG & Tailwind",
    "FIRSTNAME": "Firstname",
    "LASTNAME": "Lastname",
    "FIRSTNAME_PLACEHOLDER": "Enter your first name",
    "LASTNAME_PLACEHOLDER": "Enter your last name",
    "DATE": "Date",
    "COUNTRY": "Country",
    "MESSAGE": "Message",
    "CLEAR": "Clear",
    "SUBMIT": "Submit"
  },
  "COMPONENTS": {
    "TITLE": "Tailwind Components with PrimeNG"
  },
  "SUCCESS": {
    "TITLE": "Success!",
    "MESSAGE": "Form submitted successfully! Your integration is working perfectly."
  },
  "CLOSE": "Close",
  "login": {
    "title": "Sign in to your account",
    "subtitle": "Please enter your credentials to continue",
    "email": "Email Address",
    "password": "Password",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "signIn": "Sign In",
    "forgotPassword": "Forgot your password?",
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 6 characters long"
    }
  },
  "forgotPassword": {
    "title": "Reset your password",
    "subtitle": "Enter your email address and we'll send you a reset link",
    "email": "Email Address",
    "emailPlaceholder": "Enter your email address",
    "sendReset": "Send Reset Link",
    "backToLogin": "Back to Sign In",
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address"
    }
  },
  "home": {
    "appName": "Mosaic Admin",
    "toggleMenu": "Toggle menu",
    "navigation": "Navigation"
  },
  "navigation": {
    "launchpadProjects": "Launchpad Projects",
    "contentManagement": "Content Management",
    "adminSettings": "Admin Settings",
    "admin": "Admin",
    "adminUsers": "Admin Users",
    "platformContent": "Platform Content"
  },
  "platformInsights": {
    "title": "Platform Insights",
    "subtitle": "View analytics and insights for the platform",
    "description": "This page will display platform analytics, metrics, and insights.",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "yearly": "Year",
    "totalFunds": {
      "title": "Total Funds Raised",
      "raisedAmount": "Raised amount in USDT"
    },
    "activeLaunches": {
      "title": "Project Distribution"
    },
    "totalInvestors": {
      "title": "Total Number of Investors",
      "numberOf": "Number of Investors",
      "totalCount": "Total Unique Investors"
    },
    "pendingApprovals": {
      "title": "Projects Waiting for Approval",
      "noData": "No projects pending approval",
      "viewDetails": "View project details"
    }
  },
  "projectOwners": {
    "title": "Project Owners",
    "subtitle": "Manage project owners and their permissions",
    "email": "Email",
    "fullName": "Full Name",
    "projects": "Projects",
    "createdAt": "Created At",
    "actions": "Actions",
    "addProjectOwner": "Add Project Owner",
    "searchPlaceholder": "Search project owners...",
    "edit": "Edit project owner",
    "delete": "Delete project owner",
    "noData": "No project owners found",
    "confirmDelete": {
      "header": "Confirm Delete",
      "message": "Are you sure you want to delete project owner \"{{email}}\"?",
      "confirm": "Delete",
      "cancel": "Cancel"
    }
  },
  "projectOwnerEdit": {
    "titleEdit": "Edit Project Owner",
    "titleAdd": "Add Project Owner",
    "subtitleEdit": "Update project owner information",
    "subtitleAdd": "Create a new project owner account",
    "email": "Email Address",
    "username": "Username",
    "password": "Password",
    "fullName": "Full Name",
    "company": "Company",
    "emailPlaceholder": "Enter email address",
    "usernamePlaceholder": "Enter username",
    "passwordPlaceholder": "Enter password (minimum 8 characters)",
    "fullNamePlaceholder": "Enter full name (optional)",
    "companyPlaceholder": "Enter company name (optional)",
    "save": "Save Changes",
    "saving": "Saving...",
    "create": "Create Project Owner",
    "creating": "Creating...",
    "cancel": "Cancel",
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address",
      "usernameRequired": "Username is required",
      "usernameMinLength": "Username must be at least 3 characters long",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 8 characters long",
      "loadTitle": "Failed to Load",
      "loadMessage": "Unable to load project owner data. Please try again."
    },
    "success": {
      "editTitle": "Project Owner Updated",
      "editMessage": "Project owner information has been successfully updated.",
      "createTitle": "Project Owner Created",
      "createMessage": "New project owner account has been successfully created.",
      "deleteTitle": "Project Owner Deleted",
      "deleteMessage": "Project owner \"{{email}}\" has been successfully deleted."
    },
    "error": {
      "loadTitle": "Failed to Load",
      "loadMessage": "Unable to load project owner data. Please try again."
    },
    "projectsTitle": "Projects Owned",
    "viewProjectDetails": "View project details",
    "noProjects": "No projects found for this owner"
  },
  "adminUsers": {
    "title": "Admin Users",
    "subtitle": "Manage administrative users and their access",
    "email": "Email",
    "username": "Username",
    "actions": "Actions",
    "addAdminUser": "Add Admin User",
    "searchPlaceholder": "Search admin users...",
    "edit": "Edit admin user",
    "delete": "Delete admin user",
    "noData": "No admin users found",
    "confirmDelete": {
      "header": "Confirm Delete",
      "message": "Are you sure you want to delete admin user \"{{username}}\"?",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "success": {
      "deleteTitle": "Admin User Deleted",
      "deleteMessage": "Admin user \"{{username}}\" has been successfully deleted."
    },
    "error": {
      "loadFailed": "Failed to Load Admin Users",
      "tryAgain": "Unable to load admin users. Please try again later."
    }
  },
  "adminUserEdit": {
    "editTitle": "Edit Admin User",
    "editSubtitle": "Update admin user information",
    "createTitle": "Add Admin User",
    "createSubtitle": "Create a new admin user account",
    "titleEdit": "Edit Admin User",
    "titleAdd": "Add Admin User",
    "subtitleEdit": "Update admin user information",
    "subtitleAdd": "Create a new admin user account",
    "userDataTitle": "User Information",
    "userDataDescription": "Enter the basic user account details",
    "email": "Email Address",
    "username": "Username",
    "password": "Password",
    "passwordConfirm": "Confirm Password",
    "permissions": "Permissions",
    "permissionsDescription": "Select the permissions that this admin user should have",
    "emailPlaceholder": "Enter email address",
    "usernamePlaceholder": "Enter username",
    "passwordPlaceholder": "Enter password (minimum 8 characters)",
    "passwordConfirmPlaceholder": "Re-enter password",
    "save": "Save Changes",
    "saving": "Saving...",
    "create": "Create Admin User",
    "creating": "Creating...",
    "cancel": "Cancel",
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address",
      "usernameRequired": "Username is required",
      "usernameMinLength": "Username must be at least 3 characters long",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 8 characters long",
      "passwordConfirmRequired": "Password confirmation is required",
      "passwordMismatch": "Passwords do not match",
      "loadFailed": "Failed to load user data",
      "saveFailed": "Failed to save user data. Please try again."
    },
    "success": {
      "editTitle": "Admin User Updated",
      "editMessage": "Admin user information has been successfully updated.",
      "createTitle": "Admin User Created",
      "createMessage": "New admin user account has been successfully created."
    }
  },
  "common": {
    "ok": "OK",
    "goBack": "Go Back",
    "logout": "Logout",
    "copied": "Copied",
    "copiedToClipboard": "Address copied to clipboard",
    "cancel": "Cancel",
    "save": "Save",
    "update": "Update",
    "create": "Create",
    "delete": "Delete",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "feature": "Feature",
    "unfeature": "Unfeature",
    "approve": "Approve",
    "reject": "Reject",
    "unsaved": "Unsaved",
    "saving": "Saving",
    "savedAt": "Saved",
    "success": "Success",
    "error": "Error",
    "info": "Info",
    "warning": "Warning",
    "noChangesToSave": "All changes have been saved"
  },
  "validation": {
    "required": "This field is required"
  },
  "errors": {
    "title": "Error",
    "warning": "Warning",
    "info": "Information",
    "unknown": "An unexpected error occurred. Please try again.",
    "network": "Network error. Please check your internet connection.",
    "server": "Server error. Please try again later.",
    "unauthorized": "You are not authorized. Please log in.",
    "forbidden": "You don't have permission to perform this action.",
    "validation.permission-denied": "Permission denied.",
    "validation.invalid-token": "Invalid authentication token.",
    "validation.invalid-credentials": "Invalid email or password.",
    "validation.invalid-activation-data": "Invalid activation data.",
    "validation.insufficient-permissions": "Insufficient permissions.",
    "validation.unauthenticated": "You must be logged in to perform this action.",
    "validation.user-not-found": "User not found. Please check your credentials.",
    "validation.user-already-activated": "This account is already activated.",
    "validation.email-already-exists": "This email is already registered.",
    "validation.username-already-exists": "This username is already taken.",
    "validation.missing-required-fields": "Missing required fields.",
    "validation.password-change-code-expired": "Password reset code has expired.",
    "validation.google-verification-failed": "Google verification failed.",
    "validation.google-client-id-not-configured": "Google OAuth is not configured.",
    "validation.api-token-not-found": "Authentication token not found.",
    "validation.login-not-found": "Login session not found.",
    "validation.invalid-role": "Invalid role specified."
  },
  "projects": {
    "title": "Projects",
    "subtitle": "Manage and configure projects",
    "addProject": "Add Project",
    "editProject": "Edit Project",
    "addProjectSubtitle": "Create a new project with detailed configuration",
    "editProjectSubtitle": "Update project information and settings",
    "searchPlaceholder": "Search projects...",
    "noData": "No projects found",
    "headers": {
      "name": "Name",
      "ownerName": "Owner",
      "status": "Status",
      "publishedAt": "Publish Date",
      "currentRaised": "Total Funds Raised",
      "participantsCount": "Participants",
      "actions": "Actions"
    },
    "status": {
      "draft": "Draft",
      "pending_approval": "Pending Approval",
      "approved": "Approved",
      "rejected": "Rejected",
      "published": "Published"
    },
    "card": {
      "status": {
        "upcoming": "Upcoming",
        "privateSale": "Private Sale Round",
        "publicSale": "Public Sale Round",
        "claiming": "Claiming",
        "funded": "Funded",
        "refunded": "Refunded"
      }
    },
    "approve": "Approve project",
    "reject": "Reject project",
    "edit": "Edit project",
    "delete": "Delete project",
    "refresh": "Refresh projects list",
    "confirmDelete": {
      "header": "Confirm Delete",
      "message": "Are you sure you want to delete project \"{{name}}\"?",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "success": {
      "deleteTitle": "Project Deleted",
      "deleteMessage": "Project \"{{name}}\" has been successfully deleted."
    }
  },
  "categories": {
    "title": "Categories",
    "subtitle": "Manage project categories",
    "addCategory": "Add Category",
    "searchPlaceholder": "Search categories...",
    "noData": "No categories found",
    "headers": {
      "label": "Label",
      "description": "Description",
      "count": "Projects",
      "actions": "Actions"
    },
    "edit": "Edit category",
    "delete": "Delete category",
    "createTitle": "Create Category",
    "editTitle": "Edit Category",
    "form": {
      "label": "Category Name",
      "labelPlaceholder": "e.g. DeFi, NFT, Gaming",
      "labelHint": "The category name must be unique.",
      "description": "Description",
      "descriptionPlaceholder": "Brief description of this category"
    },
    "loadError": "Failed to load categories",
    "createSuccess": "Category created successfully",
    "createError": "Failed to create category",
    "updateSuccess": "Category updated successfully",
    "updateError": "Failed to update category",
    "deleteSuccess": "Category deleted successfully",
    "deleteError": "Failed to delete category. Make sure no projects are using this category.",
    "deleteConfirmHeader": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete category \"{{name}}\"? This action cannot be undone."
  },
  "blockchains": {
    "title": "Blockchains",
    "subtitle": "Manage supported blockchains",
    "addBlockchain": "Add Blockchain",
    "searchPlaceholder": "Search blockchains...",
    "noData": "No blockchains found",
    "headers": {
      "label": "Label",
      "description": "Description",
      "actions": "Actions"
    },
    "edit": "Edit blockchain",
    "delete": "Delete blockchain",
    "createTitle": "Create Blockchain",
    "editTitle": "Edit Blockchain",
    "form": {
      "label": "Blockchain Name",
      "labelPlaceholder": "e.g. Ethereum, Polygon, BNB Chain",
      "labelHint": "The blockchain name must be unique.",
      "description": "Description",
      "descriptionPlaceholder": "Brief description of this blockchain",
      "chainId": "Chain ID",
      "chainIdPlaceholder": "e.g. 1 for Ethereum, 137 for Polygon",
      "chainIdHint": "Numeric identifier for the blockchain network (EVM only)",
      "isEVM": "EVM Compatible",
      "rpcUrl": "RPC URL",
      "rpcUrlPlaceholder": "e.g. https://eth.llamarpc.com",
      "explorerUrl": "Block Explorer URL",
      "explorerUrlPlaceholder": "e.g. https://etherscan.io",
      "explorerApiUrl": "Explorer API URL",
      "explorerApiUrlPlaceholder": "e.g. https://api.etherscan.io/api",
      "explorerApiUrlHint": "Used for automatic ABI fetching from verified contracts"
    },
    "loadError": "Failed to load blockchains",
    "createSuccess": "Blockchain created successfully",
    "createError": "Failed to create blockchain",
    "updateSuccess": "Blockchain updated successfully",
    "updateError": "Failed to update blockchain",
    "deleteSuccess": "Blockchain deleted successfully",
    "deleteError": "Failed to delete blockchain. Make sure no projects are using this blockchain.",
    "inUseCannotDelete": "This blockchain is used by one or more projects and cannot be deleted.",
    "deleteConfirmHeader": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete blockchain \"{{name}}\"? This action cannot be undone."
  },
  "projectEdit": {
    "addTitle": "Add Project",
    "editTitle": "Edit Project",
    "addProjectSubtitle": "Create a new project with detailed configuration",
    "editSubtitle": "Update project information and settings",
    "projectInformation": "Project Information",
    "additionalContent": "Additional Content",
    "projectOverview": {
      "title": "Project Overview",
      "description": "Provide a detailed description of your project",
      "placeholder": "Enter a comprehensive overview of your project, including its goals, features, and benefits..."
    },
    "projectName": "Project Name",
    "selectProjectOwner": "Select Project Owner",
    "searchProjectOwnerPlaceholder": "Search by email...",
    "projectOwnerRequired": "Project owner is required",
    "ownerName": "Owner Name",
    "ownerUrl": "Project Website",
    "description": "Description",
    "categories": "Categories",
    "categoriesPlaceholder": "Choose the categories that apply to your project.",
    "categoriesRequired": "At least one category is required",
    "location": "Location",
    "followOn": "Follow on:",
    "documentation": "Documentation:",
    "tokenInformation": "Token Information",
    "usdt": "USDT",
    "dash": "–",
    "tokenName": "Name",
    "tokenSymbol": "Symbol",
    "tokenAddress": "Address",
    "totalSupply": "Total Supply",
    "totalSupplyTooltip": "The maximum number of tokens that will ever exist",
    "swapOn": "Swap On",
    "swapOnTooltip": "The blockchain network where tokens can be traded",
    "claimOn": "Claim On",
    "claimOnText": "Every project is claimed on Mosaic Chain",
    "claimOnTooltip": "The blockchain network where tokens can be claimed",
    "publicSalePrice": "Public Sale Price",
    "publicSalePriceTooltip": "Price per token during the public sale",
    "privateSalePrice": "Private Sale Price",
    "privateSalePriceTooltip": "Price per token during the private sale",
    "publicSalePriceSupply": "Public Sale Price Supply",
    "privateSalePriceSupply": "Private Sale Price Supply",
    "saleInformation": "Sale Information",
    "softCap": "SoftCap",
    "softCapTooltip": "Minimum funding goal for the project to proceed",
    "hardCap": "HardCap",
    "hardCapTooltip": "Maximum funding goal for the token sale",
    "minMaxAllocation": "Min/Max Allocation",
    "minMaxAllocationTooltip": "Minimum and maximum investment amounts per participant",
    "totalTokensForSale": "Total Tokens for Sale",
    "totalTokensTooltip": "Total number of tokens available in this sale",
    "poolTypes": "Pool Types",
    "poolTypesText": "Private sale round/Public sale round",
    "poolTypesTooltip": "Types of investment pools available",
    "unsoldTokens": "Unsold Tokens",
    "unsoldTokensTooltip": "What happens to tokens that aren't sold",
    "investmentRounds": "Investment Rounds",
    "autoLinkDates": "Use consecutive period dates",
    "autoLinkDatesTooltip": "When enabled, each period's end date is automatically set to the start of the next period. Private Sale ends at Public Sale start, Public Sale ends at TGE.",
    "privateSale": "Private Sale",
    "publicSale": "Public Sale",
    "tgeDate": "TGE Date",
    "oneUsdtEquals": "1 USDT =",
    "tgeDateAndTime": "TGE Date & Time",
    "startDateAndTime": "Start Date & Time",
    "endDateAndTime": "End Date & Time",
    "selectStartDate": "Select start date",
    "selectEndDate": "Select end date",
    "selectTgeDate": "Select TGE date",
    "imageUploaded": "Image uploaded successfully",
    "imageUploadError": "Failed to upload image. Please try again.",
    "changeImage": "Change",
    "uploadImageButton": "Upload",
    "name": "Project Name",
    "namePlaceholder": "Enter project name",
    "subtitle": "Project Subtitle",
    "subtitlePlaceholder": "Enter project subtitle",
    "exchangeRate": "Exchange Rate (USD)",
    "exchangeRatePlaceholder": "Enter exchange rate",
    "privateInvestmentStart": "Private Investment Start",
    "privateInvestmentStartPlaceholder": "Select date and time",
    "publicInvestmentStart": "Public Investment Start",
    "publicInvestmentStartPlaceholder": "Select date and time",
    "investmentEnds": "Investment Ends",
    "investmentEndsPlaceholder": "Select date and time",
    "fileUpload": "Project Images",
    "chooseFiles": "Choose Files",
    "uploadFiles": "Upload",
    "clearFiles": "Clear",
    "cancelUpload": "Cancel",
    "dragDropFiles": "Drag and drop files here or click to browse",
    "supportedFormats": "Supported formats: JPG, PNG, GIF (Max 10MB per file)",
    "filesSelected": "files selected",
    "addMore": "Add More",
    "clearAll": "Clear All",
    "noImagesYet": "No images added yet",
    "addImagesDescription": "Add images to showcase your project",
    "pendingFiles": "Pending Files",
    "uploadedFiles": "Uploaded Files",
    "imagePreview": "Image Preview",
    "selectedImages": "Selected Images",
    "deleteFile": "Delete file",
    "noImagesSelected": "No Images Selected",
    "noImagesDescription": "Upload images to showcase your project",
    "fileUploadSuccess": "Upload Success",
    "filesUploaded": "Files have been uploaded successfully",
    "save": "Save Changes",
    "saving": "Saving...",
    "create": "Create Project",
    "creating": "Creating...",
    "cancel": "Cancel",
    "next": "Next",
    "back": "Back",
    "projectNamePlaceholder": "Project name",
    "ownerNamePlaceholder": "Enter owner name",
    "ownerNameRequired": "Owner name is required",
    "ownerPlaceholder": "Owner URL",
    "ownerUrlRequired": "Owner website URL is required",
    "descriptionPlaceholder": "Write a short summary of your project.",
    "locationPlaceholder": "Select a country",
    "locationFilterPlaceholder": "Search countries",
    "tokenNamePlaceholder": "Token name",
    "tokenSymbolPlaceholder": "Token symbol",
    "tokenAddressPlaceholder": "Token address",
    "totalSupplyPlaceholder": "Total supply",
    "swapOnPlaceholder": "Select blockchain",
    "swapOnFilterPlaceholder": "Search blockchains",
    "claimOnPlaceholder": "Platform",
    "publicSalePricePlaceholder": "Price per token",
    "privateSalePricePlaceholder": "Price per token",
    "softCapPlaceholder": "Soft cap amount",
    "hardCapPlaceholder": "Hard cap amount",
    "minAllocationPlaceholder": "Min",
    "maxAllocationPlaceholder": "Max",
    "totalTokensForSalePlaceholder": "Total tokens",
    "poolTypesPlaceholder": "Pool types description",
    "unsoldTokensPlaceholder": "Unsold tokens policy",
    "tgePricePlaceholder": "TGE price",
    "nameRequired": "Project name is required",
    "descriptionRequired": "Project description is required",
    "descriptionMaxLength": "Project description cannot exceed 600 characters",
    "verified": "Verified",
    "micaCompliant": "MiCA Compliant",
    "socialLinks": "Social Links",
    "twitterPlaceholder": "Twitter URL",
    "linkedinPlaceholder": "LinkedIn URL",
    "telegramPlaceholder": "Telegram URL",
    "discordPlaceholder": "Discord URL",
    "whitepaperPlaceholder": "Whitepaper URL",
    "tokenomicsPlaceholder": "Tokenomics URL",
    "ownerUrlPlaceholder": "https://example.com",
    "invalidUrl": "Please enter a valid URL (e.g., https://example.com)",
    "imageTooLarge": "Image file is too large (max 5MB)",
    "invalidImageType": "Please select a valid image file (PNG, JPG, JPEG, WebP, GIF)",
    "requiredField": "{{field}} is required",
    "minLengthError": "{{field}} must be at least {{min}} characters long",
    "maxLengthError": "{{field}} cannot exceed {{max}} characters",
    "minValueError": "{{field}} must be at least {{min}}",
    "invalidFormat": "{{field}} has an invalid format",
    "invalidField": "{{field}} is invalid",
    "tokenNameRequired": "Token name is required",
    "tokenSymbolRequired": "Token symbol is required",
    "tokenAddressRequired": "Token address is required",
    "totalSupplyRequired": "Total supply is required",
    "swapOnRequired": "Swap platform is required",
    "claimOnRequired": "Claim platform is required",
    "publicSalePriceRequired": "Public sale price is required",
    "privateSalePriceRequired": "Private sale price is required",
    "softCapRequired": "Soft cap is required",
    "hardCapRequired": "Hard cap is required",
    "minAllocationRequired": "Minimum allocation is required",
    "maxAllocationRequired": "Maximum allocation is required",
    "totalTokensForSaleRequired": "Total tokens for sale is required",
    "poolTypesRequired": "Pool types is required",
    "unsoldTokensRequired": "Unsold tokens policy is required",
    "privateSaleStartRequired": "Private sale start date is required",
    "privateSaleEndRequired": "Private sale end date is required",
    "publicSaleStartRequired": "Public sale start date is required",
    "publicSaleEndRequired": "Public sale end date is required",
    "tgeDateRequired": "TGE date is required",
    "tgePriceRequired": "TGE price is required",
    "roadmap": {
      "title": "Project Roadmap",
      "image": "Roadmap Image",
      "chooseImage": "Choose Image",
      "removeImage": "Remove image",
      "url": "Roadmap URL",
      "urlPlaceholder": "Enter roadmap link (e.g., https://example.com/roadmap)"
    },
    "tokenomics": {
      "title": "Project Tokenomics",
      "image": "Tokenomics Image",
      "chooseImage": "Choose Image",
      "removeImage": "Remove image",
      "url": "Tokenomics URL",
      "urlPlaceholder": "Enter tokenomics link (e.g., https://example.com/tokenomics)"
    },
    "teamMembers": {
      "title": "Team Members",
      "addMember": "Add Member",
      "editMember": "Edit Member",
      "updateMember": "Update Member",
      "removeMember": "Remove Member",
      "addFirstMember": "Add First Member",
      "noMembers": "No Team Members Yet",
      "noMembersDescription": "Start building your team by adding your first team member",
      "image": "Profile Image",
      "chooseImage": "Choose Image",
      "removeImage": "Remove image",
      "name": "Full Name",
      "namePlaceholder": "Enter full name",
      "position": "Position/Title",
      "positionPlaceholder": "Enter position or job title",
      "linkedinUrl": "LinkedIn Profile",
      "linkedinUrlPlaceholder": "Enter LinkedIn profile URL",
      "description": "Description",
      "descriptionPlaceholder": "Enter a brief description about this team member",
      "viewLinkedIn": "View LinkedIn",
      "addSuccess": "Team member \"{{name}}\" added successfully",
      "updateSuccess": "Team member \"{{name}}\" updated successfully",
      "removeSuccess": "Team member \"{{name}}\" removed successfully"
    },
    "tokenAllocation": {
      "title": "Token Allocation",
      "tokenSupply": "Token Supply",
      "privateSale": "Private Sale",
      "publicSale": "Public Sale",
      "allocations": "Allocations",
      "addAllocation": "Add Allocation",
      "editAllocation": "Edit Allocation",
      "updateAllocation": "Update Allocation",
      "removeAllocation": "Remove Allocation",
      "name": "Allocation Name",
      "namePlaceholder": "Allocation name",
      "color": "Color",
      "percentage": "Percentage",
      "emptyMessage": "No allocations added yet. Click 'Add Allocation' to get started.",
      "total": "Total",
      "addSuccess": "Token allocation \"{{name}}\" added successfully",
      "updateSuccess": "Token allocation \"{{name}}\" updated successfully",
      "removeSuccess": "Token allocation \"{{name}}\" removed successfully"
    },
    "vestingCategories": {
      "title": "Vesting Categories",
      "addButton": "Add Category",
      "addCategory": "Add Vesting Category",
      "editCategory": "Edit Vesting Category",
      "updateCategory": "Update Category",
      "editTitle": "Edit Vesting Category",
      "addTitle": "Add Vesting Category",
      "category": "Category",
      "categoryLabel": "Category",
      "categoryPlaceholder": "Enter category name",
      "walletAddress": "Wallet Address",
      "walletAddressPlaceholder": "0x...",
      "walletAddressRequired": "Wallet address is required",
      "walletAddressInvalid": "Please enter a valid Ethereum wallet address (0x...)",
      "cliffPeriod": "Cliff Period",
      "cliffPeriodLabel": "Cliff period (months)",
      "cliffPeriodPlaceholder": "Enter number of months (minimum 1)",
      "vestingPeriod": "Vesting Period",
      "vestingPeriodLabel": "Vesting Period",
      "vestingPeriodPlaceholder": "Enter vesting period in months",
      "vestingDuration": "Vesting Duration",
      "vestingDurationLabel": "Vesting duration (months)",
      "vestingDurationPlaceholder": "Enter number of months (minimum 1)",
      "releasingFrequency": "Releasing Frequency",
      "releasingFrequencyLabel": "Releasing Frequency",
      "releasingFrequencyPlaceholder": "Enter releasing frequency",
      "initialUnlock": "Initial Unlock",
      "initialUnlockLabel": "Initial Unlock",
      "initialUnlockPlaceholder": "Enter initial unlock percentage",
      "tgeUnlock": "TGE Unlock %",
      "tgeUnlockLabel": "TGE Unlock %",
      "tgeUnlockPlaceholder": "Enter TGE unlock percentage",
      "firstClaim": "First claim available (months after TGE)",
      "firstClaimLabel": "First claim available (months after TGE)",
      "firstClaimPlaceholder": "Enter number of months after TGE",
      "firstClaimRequired": "First claim timing is required",
      "firstClaimMin": "First claim value must be 0 or greater",
      "months": "months",
      "emptyMessage": "No vesting categories added yet. Click 'Add Category' to get started.",
      "addSuccess": "Vesting category \"{{category}}\" added successfully",
      "updateSuccess": "Vesting category \"{{category}}\" updated successfully",
      "removeSuccess": "Vesting category \"{{category}}\" removed successfully"
    },
    "updates": {
      "title": "Updates",
      "addUpdate": "Add Update",
      "editUpdate": "Edit Update",
      "updateUpdate": "Update",
      "removeUpdate": "Remove Update",
      "addFirstUpdate": "Add First Update",
      "noUpdates": "No Updates Yet",
      "noUpdatesDescription": "Keep your community informed by adding project updates",
      "coverImage": "Cover Image",
      "chooseCoverImage": "Choose Cover Image",
      "removeCoverImage": "Remove cover image",
      "updateTitle": "Title",
      "titlePlaceholder": "Enter update title",
      "text": "Content",
      "textPlaceholder": "Enter update content",
      "publishDate": "Publish Date",
      "publishDatePlaceholder": "Select publish date",
      "addSuccess": "Update \"{{title}}\" added successfully",
      "updateSuccess": "Update \"{{title}}\" updated successfully",
      "removeSuccess": "Update \"{{title}}\" removed successfully"
    },
    "actions": "Actions",
    "edit": "Edit",
    "remove": "Remove",
    "errors": {
      "nameRequired": "Project name is required",
      "nameMinLength": "Project name must be at least 3 characters long",
      "nameMaxLength": "Project name cannot exceed 30 characters",
      "subtitleRequired": "Project subtitle is required",
      "subtitleMinLength": "Project subtitle must be at least 3 characters long",
      "exchangeRateRequired": "Exchange rate is required",
      "exchangeRateMin": "Exchange rate must be greater than 0",
      "privateInvestmentStartRequired": "Private investment start date is required",
      "publicInvestmentStartRequired": "Public investment start date is required",
      "investmentEndsRequired": "Investment end date is required",
      "roadmapUrlInvalid": "Please enter a valid URL (must start with http:// or https://)",
      "tokenomicsUrlInvalid": "Please enter a valid URL (must start with http:// or https://)",
      "teamMemberImageRequired": "Team member image is required",
      "teamMemberNameRequired": "Team member name is required",
      "teamMemberNameMinLength": "Name must be at least 2 characters long",
      "teamMemberPositionRequired": "Position is required",
      "teamMemberPositionMinLength": "Position must be at least 2 characters long",
      "teamMemberLinkedinUrlRequired": "LinkedIn URL is required",
      "teamMemberLinkedinUrlInvalid": "Please enter a valid LinkedIn URL",
      "teamMemberDescriptionRequired": "Description is required",
      "teamMemberDescriptionMinLength": "Description must be at least 10 characters long",
      "teamMemberDescriptionMaxLength": "Description must not exceed 250 characters",
      "vestingCategoryRequired": "Vesting category name is required",
      "vestingCategoryMinLength": "Category name must be at least 2 characters long",
      "cliffPeriodRequired": "Cliff period is required",
      "cliffPeriodMin": "Cliff period must be at least 1 month",
      "vestingDurationRequired": "Vesting duration is required",
      "vestingDurationMin": "Vesting duration must be at least 1 month",
      "vestingPeriodRequired": "Vesting period is required",
      "vestingPeriodMin": "Vesting period must be greater than 0",
      "releasingFrequencyRequired": "Releasing frequency is required",
      "releasingFrequencyMinLength": "Releasing frequency must be at least 2 characters long",
      "initialUnlockRequired": "Initial unlock percentage is required",
      "initialUnlockMin": "Initial unlock must be 0 or greater",
      "initialUnlockMax": "Initial unlock cannot exceed 100%",
      "updateTitleRequired": "Update title is required",
      "updateTitleMinLength": "Title must be at least 3 characters long",
      "updateTextRequired": "Update content is required",
      "updateTextMinLength": "Content must be at least 10 characters long",
      "updatePublishDateRequired": "Publish date is required",
      "locationRequired": "Location is required",
      "swapOnRequired": "Swap blockchain is required",
      "claimOnRequired": "Claim platform is required"
    },
    "success": {
      "imageUploadedTitle": "Image Uploaded",
      "imageUploadedMessage": "Project image has been successfully uploaded.",
      "editTitle": "Project Updated",
      "editMessage": "Project information has been successfully updated.",
      "createTitle": "Project Created",
      "createMessage": "New project has been successfully created.",
      "publishTitle": "Project Published",
      "publishMessage": "The project has been successfully published and is now visible to users.",
      "unpublishTitle": "Project Unpublished",
      "unpublishMessage": "The project has been unpublished and is now hidden from users.",
      "featureTitle": "Project Featured",
      "featureMessage": "The project has been featured and will display prominently on the homepage.",
      "unfeatureTitle": "Project Unfeatured",
      "unfeatureMessage": "The project has been removed from the featured section."
    },
    "saveInProgress": {
      "message": "A save is currently in progress. Are you sure you want to leave? Unsaved changes may be lost."
    },
    "autoSaveFailed": "Auto-save failed. Please check your connection and try again.",
    "approval": {
      "approveProject": "Approve Project",
      "confirmApprove": "Are you sure you want to approve this project? The project owner will be notified.",
      "approveSuccess": "Project Approved",
      "approveSuccessMessage": "The project has been approved successfully. You can now publish it.",
      "rejectProject": "Reject Project",
      "confirmReject": "Are you sure you want to reject this project? The project owner will be able to edit and resubmit it.",
      "rejectSuccess": "Project Rejected",
      "rejectSuccessMessage": "The project has been rejected. The project owner has been notified and can make changes."
    },
    "publish": {
      "confirmHeader": "Publish Without Approval",
      "confirmUnapproved": "This project has not gone through the standard approval process. Publishing it will make it immediately visible to all users. Are you sure you want to proceed?"
    }
  },
  "successStories": {
    "title": "Success Stories",
    "subtitle": "Showcase your most successful projects and achievements",
    "addStory": "Add Story",
    "adding": "Adding...",
    "addFirstStory": "Add First Story",
    "editStory": "Edit Story",
    "updateStory": "Update Story",
    "updating": "Updating...",
    "removeStory": "Remove Story",
    "viewStory": "View Story",
    "noStories": "No Success Stories Yet",
    "noStoriesDescription": "Start showcasing your achievements by adding your first success story",
    "addTitle": "Add Success Story",
    "editTitle": "Edit Success Story",
    "cancel": "Cancel",
    "coverImage": "Cover Image",
    "chooseImage": "Choose Image",
    "removeImage": "Remove image",
    "imagePreview": "Image Preview",
    "storyTitle": "Title",
    "titlePlaceholder": "Enter story title",
    "description": "Description",
    "descriptionPlaceholder": "Enter a detailed description of this success story",
    "linkUrl": "Story Link",
    "linkUrlPlaceholder": "Enter the URL to the full story (e.g., https://example.com/story)",
    "errors": {
      "titleRequired": "Story title is required",
      "titleMinLength": "Title must be at least 3 characters long",
      "titleMaxLength": "Title cannot exceed {{max}} characters",
      "descriptionRequired": "Story description is required",
      "descriptionMinLength": "Description must be at least 10 characters long",
      "descriptionMaxLength": "Description cannot exceed {{max}} characters",
      "linkUrlRequired": "Story link is required",
      "linkUrlInvalid": "Please enter a valid URL (must start with http:// or https://)",
      "loadFailed": "Failed to load success stories. Please try again.",
      "saveFailed": "Failed to save success story. Please try again.",
      "deleteFailed": "Failed to delete success story. Please try again."
    },
    "success": {
      "addTitle": "Story Added",
      "addMessage": "Success story has been successfully added.",
      "editTitle": "Story Updated",
      "editMessage": "Success story has been successfully updated.",
      "removeTitle": "Story Removed",
      "removeMessage": "Success story has been successfully removed."
    },
    "confirmDelete": {
      "header": "Confirm Deletion",
      "message": "Are you sure you want to delete '{{title}}'? This action cannot be undone."
    }
  },
  "learnMore": {
    "title": "Learn More",
    "subtitle": "Educational resources and guides for better understanding",
    "addItem": "Add Item",
    "adding": "Adding...",
    "addFirstItem": "Add First Item",
    "editItem": "Edit Item",
    "updateItem": "Update Item",
    "updating": "Updating...",
    "removeItem": "Remove Item",
    "viewItem": "View Resource",
    "noItems": "No Learning Resources Yet",
    "noItemsDescription": "Start building your knowledge base by adding your first learning resource",
    "addTitle": "Add Learning Resource",
    "editTitle": "Edit Learning Resource",
    "cancel": "Cancel",
    "coverImage": "Cover Image",
    "chooseImage": "Choose Image",
    "removeImage": "Remove image",
    "imagePreview": "Image Preview",
    "itemTitle": "Title",
    "titlePlaceholder": "Enter resource title",
    "description": "Description",
    "descriptionPlaceholder": "Enter a detailed description of this learning resource",
    "linkUrl": "Resource Link",
    "linkUrlPlaceholder": "Enter the URL to the learning resource (e.g., https://example.com/guide)",
    "errors": {
      "titleRequired": "Resource title is required",
      "titleMinLength": "Title must be at least 3 characters long",
      "titleMaxLength": "Title cannot exceed {{max}} characters",
      "descriptionRequired": "Resource description is required",
      "descriptionMinLength": "Description must be at least 10 characters long",
      "descriptionMaxLength": "Description cannot exceed {{max}} characters",
      "linkUrlRequired": "Resource link is required",
      "linkUrlInvalid": "Please enter a valid URL (must start with http:// or https://)",
      "loadFailed": "Failed to load learning resources. Please try again.",
      "saveFailed": "Failed to save learning resource. Please try again.",
      "deleteFailed": "Failed to delete learning resource. Please try again."
    },
    "success": {
      "addTitle": "Resource Added",
      "addMessage": "Learning resource has been successfully added.",
      "editTitle": "Resource Updated",
      "editMessage": "Learning resource has been successfully updated.",
      "removeTitle": "Resource Removed",
      "removeMessage": "Learning resource has been successfully removed."
    },
    "confirmDelete": {
      "header": "Confirm Deletion",
      "message": "Are you sure you want to delete '{{title}}'? This action cannot be undone."
    }
  },
  "investmentTier": {
    "addTitle": "Add Investment Tier",
    "editTitle": "Edit Investment Tier",
    "addSubtitle": "Create a new investment tier for your project",
    "editSubtitle": "Update investment tier information",
    "title": "Tier Title",
    "titlePlaceholder": "Enter tier title (e.g., Bronze Supporter - 100 USDT)",
    "usdtPrice": "USDT Price",
    "usdtPricePlaceholder": "Enter price in USDT",
    "eurPrice": "EUR Price",
    "eurPricePlaceholder": "Enter equivalent price in EUR",
    "bonusText": "Bonus Text",
    "bonusTextPlaceholder": "Enter bonus description (e.g., +2% bonus tokens)",
    "tokenAmount": "Token Amount",
    "tokenAmountPlaceholder": "Enter number of tokens",
    "save": "Save Changes",
    "create": "Create Tier",
    "cancel": "Cancel",
    "editTier": "Edit Tier",
    "removeTier": "Remove Tier",
    "errors": {
      "titleRequired": "Tier title is required",
      "titleMinLength": "Title must be at least 3 characters long",
      "usdtPriceRequired": "USDT price is required",
      "usdtPriceMin": "USDT price must be greater than 0",
      "eurPriceRequired": "EUR price is required",
      "eurPriceMin": "EUR price must be greater than 0",
      "bonusTextRequired": "Bonus text is required",
      "bonusTextMinLength": "Bonus text must be at least 3 characters long",
      "tokenAmountRequired": "Token amount is required",
      "tokenAmountMin": "Token amount must be at least 1"
    }
  },
  "community": {
    "title": "Community",
    "subtitle": "Manage your social media links and community connections",
    "twitter": "Twitter",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "discord": "Discord",
    "telegram": "Telegram",
    "linkedin": "LinkedIn",
    "twitterPlaceholder": "Enter your Twitter URL (e.g., https://twitter.com/yourhandle)",
    "facebookPlaceholder": "Enter your Facebook URL (e.g., https://facebook.com/yourpage)",
    "instagramPlaceholder": "Enter your Instagram URL (e.g., https://instagram.com/yourhandle)",
    "discordPlaceholder": "Enter your Discord URL (e.g., https://discord.gg/yourinvite)",
    "telegramPlaceholder": "Enter your Telegram URL (e.g., https://t.me/yourchannel)",
    "linkedinPlaceholder": "Enter your LinkedIn URL (e.g., https://linkedin.com/company/yourcompany)",
    "save": "Save Changes",
    "saving": "Saving...",
    "errors": {
      "twitterInvalid": "Please enter a valid Twitter URL",
      "facebookInvalid": "Please enter a valid Facebook URL",
      "instagramInvalid": "Please enter a valid Instagram URL",
      "discordInvalid": "Please enter a valid Discord URL",
      "telegramInvalid": "Please enter a valid Telegram URL",
      "linkedinInvalid": "Please enter a valid LinkedIn URL",
      "loadFailed": "Failed to load social media links. Please try again.",
      "saveFailed": "Failed to save social media links. Please try again."
    },
    "success": {
      "title": "Social Media Links Updated",
      "message": "Your community social media links have been successfully updated."
    }
  },
  "userMlp": {
    "title": "User MLP",
    "subtitle": "Manage user MLP balances and tier discounts",
    "addUserMlp": "Add User MLP",
    "importCsv": "Import CSV",
    "searchPlaceholder": "Search by wallet address or tier...",
    "noData": "No user MLP records found",
    "headers": {
      "walletAddress": "Wallet Address",
      "mlpAmount": "MLP Amount",
      "tier": "Tier",
      "discount": "Discount",
      "actions": "Actions"
    },
    "edit": "Edit user MLP",
    "delete": "Delete user MLP",
    "createTitle": "Add User MLP",
    "editTitle": "Edit User MLP",
    "form": {
      "walletAddress": "Wallet Address",
      "walletAddressPlaceholder": "0x...",
      "walletAddressHint": "Enter a valid Ethereum wallet address (0x...)",
      "mlpAmount": "MLP Amount",
      "mlpAmountPlaceholder": "Enter MLP amount",
      "tier": "Tier",
      "tierPlaceholder": "e.g., Bronze, Silver, Gold, Platinum",
      "tierHint": "The tier associated with this MLP amount",
      "discountPercentage": "Discount Percentage",
      "discountPercentagePlaceholder": "Enter discount (0-100)"
    },
    "loadError": "Failed to load user MLP records",
    "createSuccess": "User MLP record created successfully",
    "createError": "Failed to create user MLP record",
    "updateSuccess": "User MLP record updated successfully",
    "updateError": "Failed to update user MLP record",
    "deleteSuccess": "User MLP record deleted successfully",
    "deleteError": "Failed to delete user MLP record",
    "deleteConfirmHeader": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete the MLP record for wallet \"{{address}}\"? This action cannot be undone.",
    "invalidWalletAddress": "Please enter a valid Ethereum wallet address",
    "minValueError": "Value must be at least {{min}}",
    "maxValueError": "Value must be at most {{max}}",
    "importSuccess": "CSV file imported successfully",
    "importError": "Failed to import CSV file",
    "invalidFileType": "Please select a valid CSV file",
    "fileTooLarge": "File size exceeds 5MB limit"
  }
}
